class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
    rangeslider()
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm?.renderFilters(html, event);
        FacetFiltersForm?.renderProductGridContainer(html);
        FacetFiltersForm?.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        // // START: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
        // const allWishlistIconsFrcp = document.querySelectorAll(".frcp-wishlist__icon");
        // allWishlistIconsFrcp.forEach(function (wishlistIcon) {
        //   if (wishlistIcon.innerHTML.includes("M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z")) {
        //     wishlistIcon.outerHTML = `
        //       <svg class="frcp-wishlist__icon" preserveAspectRatio="xMidYMid slice" width="24" heigth="24" height="24"
        //         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="inherit" stroke="inherit">
        //         <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.238L17 20V4H7v16l5-4.762zm-4 2.429l4-3.81 4 3.81V5H8v12.667z">
        //         </path>
        //       </svg>
        //     `;
        //   }
        // });
        // // END: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
        updateWishlistIcons();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

    // // START: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
    // const allWishlistIconsFrcp = document.querySelectorAll(".frcp-wishlist__icon");
    // allWishlistIconsFrcp.forEach(function (wishlistIcon) {
    //   if (wishlistIcon.innerHTML.includes("M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z")) {
    //     wishlistIcon.outerHTML = `
    //       <svg class="frcp-wishlist__icon" preserveAspectRatio="xMidYMid slice" width="24" heigth="24" height="24"
    //         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="inherit" stroke="inherit">
    //         <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.238L17 20V4H7v16l5-4.762zm-4 2.429l4-3.81 4 3.81V5H8v12.667z">
    //         </path>
    //       </svg>
    //     `;
    //   }
    // });
    // // END: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
    updateWishlistIcons();
    
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    const productGrid = document.querySelector('ul.product-grid');
    const savedGridColumns = localStorage.getItem('gridColumnsDesktop') || 4;
    const columnsMobile = localStorage.getItem('gridColumnsMobile') || 2;
    productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, `grid--${savedGridColumns}-col-desktop`);
    productGrid.className = productGrid.className.replace(/grid--\d+-col-tablet-down/g, `grid--${columnsMobile}-col-tablet-down`);
    // const swymCallbackFn = (swat)=>swat.initializeActionButtons("ul.product-grid");
    // if(!window.SwymCallbacks){
    //   window.SwymCallbacks = [];
    // }
    // window.SwymCallbacks.push(swymCallbackFn);

    // START: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
    window.frcp && window.frcp.wishlist && window.frcp.wishlist.attachOnCollection();
    // END: ||-------------------->>> FRCP_WL Snippet <<<--------------------||

    attachListeners();
    productGrid.classList.add('ready');

    reinitializeInfiniteScrollFromResponse(html);
    
  }


  static renderProductCount(html) {
    const endlessCollection = new Ajaxinate({
      container: '#product-grid',
      method: 'click'
    });
    // try {
    //   // Ensure global instance exists and reuse it.
    //   if (typeof Ajaxinate === 'undefined') return;

    //   // If an instance already exists, reuse it — but update paginationElement if needed.
    //   if (window.endlessCollection && typeof window.endlessCollection === 'object') {
    //     // optionally update pagination selector if facets uses a different element
    //     var newPagination = document.querySelector('.infinite_next');
    //     if (newPagination && window.endlessCollection.paginationElement !== newPagination) {
    //       // assign and re-bind click listeners safely
    //       try {
    //         window.endlessCollection.paginationElement = newPagination;
    //         // Reinitialize click listeners safely (Ajaxinate prototype changes below make this idempotent)
    //         if (typeof window.endlessCollection.initialize === 'function') {
    //           window.endlessCollection.initialize();
    //         }
    //       } catch (e) { console.error(e); }
    //     }
    //     return;
    //   }

    //   // otherwise create a single global instance (store on window)
    //   window.endlessCollection = new Ajaxinate({
    //     container: '#product-grid',
    //     pagination: '.infinite_next',
    //     method: 'click'
    //   });
    // } catch (e) {
    //   console.error('renderProductCount Ajaxinate init error', e);
    // }
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML||"";
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if(container){
      
    container.innerHTML = count;
    container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter' 
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
    const countWhenClear = Array.from(document.querySelectorAll("#all_filter_headings .facets__summary"))
      .find(elm=>elm.id.replace("counter-","") === event?.target.closest('.js-filter').id.replace("Details-","") );
    
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
     
    }else{
      const all_labels = Array.from(document.querySelectorAll(`[data-clabel]`)).forEach(lbl=>{
      const clear_label = lbl.getAttribute("data-clabel")
      const target_filter_pill = document.querySelector(`#all_filter_headings [data-label="${clear_label}"]`)
      console.log(target_filter_pill)
      if(target_filter_pill){
        target_filter_pill?.classList.remove("active");
        const source_text = lbl?.closest(".js-filter")?.querySelector(".innerhtml")?.innerHTML
        target_filter_pill.innerHTML = source_text||target_filter_pill.innerHTML;
      }
    })
      console.log(event?.target,Array.from(document.querySelectorAll("#all_filter_headings .facets__summary")),countWhenClear)
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    try {
      
      const clear_label = source.querySelector("[data-clabel]")?.getAttribute("data-clabel");
      const target_filter_pill = document.querySelector(`#all_filter_headings [data-label="${clear_label}"]`)
      console.log(target_filter_pill);
      if(source?.querySelector(".facets__summary.active")){
        target_filter_pill?.classList.add("active");
      }else{
        target_filter_pill?.classList.remove("active");
      }
    } catch (error) {
      console.log(error);
    }
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }

    // here updating the visible filter pills according to index
    const sourceIndex = source.getAttribute("data-index")
    const targetElement = document.querySelector("form#FacetFiltersForm")?.querySelector(`.all_filter_headings .facets_index${sourceIndex}`);
    if(targetElement){
      targetElement.querySelector("span").innerHTML = sourceSummary.querySelector("span").innerHTML
    }else{
      console.log(sourceIndex,targetElement)
    }
    
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

// --- UPDATe: replace old reinitializeInfiniteScroll with this ---
function reinitializeInfiniteScrollFromResponse(htmlString) {
  // parse server response HTML
  const parsed = new DOMParser().parseFromString(htmlString, 'text/html');
  const newInfinite = parsed.querySelector('infinite-scroll');
  const existingInfinite = document.querySelector('infinite-scroll');

  if (!newInfinite || !existingInfinite) {
    // nothing to update or no infinite-scroll on the page
    return;
  }

  // Preserve parent so we can re-insert the replacement in the same place
  const parent = existingInfinite.parentElement;
  // Remove old element (this also removes any IntersectionObserver tied to that element)
  existingInfinite.remove();

  // Create a new element and copy the attributes + innerHTML from the server returned one
  const replacement = document.createElement('infinite-scroll');

  // copy dataset attributes from server element (data-next, data-page-size, etc.)
  Array.from(newInfinite.attributes).forEach((attr) => {
    replacement.setAttribute(attr.name, attr.value);
  });

  // copy inner markup (loading boxes, etc.)
  replacement.innerHTML = newInfinite.innerHTML;

  // append replacement into DOM where the old one was
  parent.appendChild(replacement);

  // when the element is added to DOM, the browser will call its custom element constructor
  // giving you a fresh InfiniteScroll instance with its IntersectionObserver initialized.
  console.log('♻️ infinite-scroll replaced with server-returned element (filters applied).');
}



customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



function productGridDesktop() {
  const button1 = document.getElementById('button-1');
  const button2 = document.getElementById('button-2');
  const button3 = document.getElementById('button-3');
  
  
  function getInitialGridStateDesktop() {
    const savedGridColumns = localStorage.getItem('gridColumnsDesktop');
    return savedGridColumns || '4';
  }

  function getInitialCardContentVisibility() {
    const savedCardContentVisibility = localStorage.getItem('cardContentVisibility');
    return savedCardContentVisibility === 'hidden';
  }
  
  button1.addEventListener('click', function() {
    updateGridColumnsDesktop('4');
    setActiveButton(button1);
    showCardContent();
    showWishlist();
    // console.log("4")
  });

  button2.addEventListener('click', function() {
    updateGridColumnsDesktop('8');
    setActiveButton(button2);
    showCardContent();
    showWishlist();
    // console.log("8")
  });

  button3.addEventListener('click', function() {
    updateGridColumnsDesktop('12');
    setActiveButton(button3);
    hideCardContent();
    hideWishlist();
    // console.log("12")
  });

  const initialGridStateDesktop = getInitialGridStateDesktop();
  const productGrid = document.querySelector('ul.product-grid');
  productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, `grid--${initialGridStateDesktop }-col-desktop`);
  productGrid?.classList.remove("grid--1-col-desktop")
  if (initialGridStateDesktop  === '4') {
    setActiveButton(button1);
  } else if (initialGridStateDesktop  === '8') {
    setActiveButton(button2);
  } else if (initialGridStateDesktop  === '12') {
    setActiveButton(button3);
  } 
  
  function updateGridColumnsDesktop(columnsDesktop) {
    const productGrid = document.querySelector('ul.product-grid');
    productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, `grid--${columnsDesktop}-col-desktop`);
    localStorage.setItem('gridColumnsDesktop', columnsDesktop);
  }

  function setActiveButton(activeButton) {
    [button1, button2, button3].forEach(button => button.classList.remove('zoom-buttom--selected'));
    activeButton.classList.add('zoom-buttom--selected');
  }

  function hideCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = '';
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  function hideWishlist() {
    const cardWishlist = document.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    cardWishlist.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showWishlist() {
    const cardWishlist = document.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    cardWishlist.forEach(content => {
      content.style.display = '';
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  if (getInitialCardContentVisibility()) {
    hideCardContent();
    hideWishlist();
  }
  productGrid.classList.add('ready');
}


function productGridMobile() {
  const button4 = document.getElementById('button-4');
  const button5 = document.getElementById('button-5');
  const button6 = document.getElementById('button-6');
  const productGrid = document.querySelector('ul.product-grid');

  function getInitialGridStateMobile() {
  const savedGridColumnsMobile = localStorage.getItem('gridColumnsMobile');
  return savedGridColumnsMobile || '2';
  }

  function getInitialCardContentVisibility() {
    const savedCardContentVisibility = localStorage.getItem('cardContentVisibility');
    return savedCardContentVisibility === 'hidden';
  }

  // Set the initial state
  const initialGridStateMobile = getInitialGridStateMobile();
  productGrid.className = productGrid.className.replace(/grid--\d+-col-tablet-down/g, `grid--${initialGridStateMobile}-col-tablet-down`);
  if (initialGridStateMobile === '2') {
    setActiveButton(button4);
  } else if (initialGridStateMobile === '3') {
    setActiveButton(button5);
  } else if (initialGridStateMobile === '4') {
    setActiveButton(button6);
  }

  button4.addEventListener('click', function() {
    updateGridColumnsMobile('2');
    setActiveButton(button4);
    showCardContent();
    showWishlist();
  });

  button5.addEventListener('click', function() {
    updateGridColumnsMobile('3');
    setActiveButton(button5);
    showCardContent();
    showWishlist();
  });

  button6.addEventListener('click', function() {
    updateGridColumnsMobile('4');
    setActiveButton(button6);
    hideCardContent();
    hideWishlist();
  });

  function updateGridColumnsMobile(columnsMobile) {
    const productGrid = document.querySelector('ul.product-grid');
  productGrid.className = productGrid.className.replace(/grid--\d+-col-tablet-down/g, `grid--${columnsMobile}-col-tablet-down`);
  localStorage.setItem('gridColumnsMobile', columnsMobile);
    scrollToInitialState();
  }

  
  function setActiveButton(activeButton) {
  [button4, button5, button6].forEach(button => button.classList.remove('zoom-buttom--selected1'));
  activeButton.classList.add('zoom-buttom--selected1');
  }

  function hideCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showCardContent() {
    const cardContents = document.querySelectorAll('.card__content');
    cardContents.forEach(content => {
      content.style.display = '';
      content.removeAttribute('href');
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  function hideWishlist() {
    const cardWishlist = document.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    cardWishlist.forEach(content => {
      content.style.display = 'none';
    });
    localStorage.setItem('cardContentVisibility', 'hidden');
  }

  function showWishlist() {
    const cardWishlist = document.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    cardWishlist.forEach(content => {
      content.style.display = '';
    });
    localStorage.setItem('cardContentVisibility', 'visible');
  }

  if (getInitialCardContentVisibility()) {
    hideCardContent();
    hideWishlist();
  }
  productGrid.classList.add('ready');
}





document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');
  const searchFacet = document.querySelector('.template-search .template-search__search');
  const facets = document.querySelector('.facets');
  
  let lastScrollTop = 0;
  let scrollTimeout;
  const scrollThreshold = 7;

  if (!facets) return;

  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 750) return;

    clearTimeout(scrollTimeout);

    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScrollTop - lastScrollTop) > scrollThreshold) {
      if (currentScrollTop > lastScrollTop) {
        facets.style.opacity = '0';
        facets.style.transform = 'translateY(-64px)';
      } else {
        facets.style.opacity = '1';
        facets.style.transform = 'translateY(0px)';
      }
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;

    scrollTimeout = setTimeout(() => {
      facets.style.opacity = '1';
      facets.style.transform = 'translateY(0px)';
    }, 2000); // Adjust delay as needed
  });

  // Immediate show facets on hover over header or searchFacet
  [header, searchFacet].forEach((el) => {
    if (el) {
      el.addEventListener('mouseenter', () => {
        facets.style.opacity = '1';
        facets.style.transform = 'translateY(0px)';
      });
    }
  });
});




